(function (window) {
    window._env = window._env || {};

    // API url
    window._env.apiUrl = 'https://hr-api.stylemix.net/api';
    window._env.routeProvider = {
        debug: true
    }
}(this));